import { jsx } from "react/jsx-runtime";
import "react";
import "../../../../foundations/icons/IconsDefault.js";
import { Text } from "../../../../foundations/typography/Text/Text.js";
const ToggletipDescription = (props) => /* @__PURE__ */ jsx(Text, { variant: "caption", component: "p", ...props });
export {
  ToggletipDescription
};
